import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import LoadingOverlay from './LoadingOverlay';

const AuthWrapper = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const [authMode, setAuthMode] = useState('login');

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <LoadingOverlay 
        show={true}
        message="Loading..."
        type="loading"
      />
    );
  }

  // If user is authenticated, show the main app
  if (isAuthenticated) {
    return children;
  }

  // Show authentication pages
  const handleSwitchToSignup = () => {
    setAuthMode('signup');
  };

  const handleSwitchToLogin = () => {
    setAuthMode('login');
  };

  return (
    <>
      {authMode === 'login' ? (
        <LoginPage onSwitchToSignup={handleSwitchToSignup} />
      ) : (
        <SignupPage onSwitchToLogin={handleSwitchToLogin} />
      )}
    </>
  );
};

export default AuthWrapper;



